import { posSettingsSchema } from "@redotech/redo-model/pos/settings";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getPosSettings = {
  name: "getPosSettings" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ settings: posSettingsSchema.nullish() }),
};
